import ServerSSRInterface from '../../interfaces/server/SSR'

export const isSpecialSSR = (ssr: ServerSSRInterface) =>
  ssr.dimensions ? Boolean(Object.keys(ssr.dimensions).length) : false

export default {
  id: 'id',
  name: 'id',
  isAddedByTourOperator: 'isAddedByTourOperator',
  availableCount: 'availableCount',
  isLimited: 'isLimited',
  isSpecialSSR,
  ssrNumber: 'ssrNumber',
}
